import { NgModule } from '@angular/core';
import { LibSharedCommonModule } from '@solvace/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { SvcOutlinedBtnComponent } from './svc-outlined-btn.component';

@NgModule({
  declarations: [
    SvcOutlinedBtnComponent
  ],
  imports: [
    LibSharedCommonModule,
    MatProgressSpinnerModule,
  ],
  exports: [
    SvcOutlinedBtnComponent
  ]
})
export class SvcOutlinedBtnModule { }
